export default __webpack_public_path__ + "static/loading-e942f61ab1a7d513fe62254a652a5ee8.gif";